export const updateStudentProfile = async ({ BeURL, formData }) => {
    try {
        if (!BeURL) {
            alert("Backend URL not provided");
            return { success: false, message: "Backend URL not provided" };
        }

        const res = await fetch(`${BeURL}/update-student-profile`, {
            method: "POST",
            body: formData,
            credentials: "include",
        });

        const data = await res.json();

        if (data.success) {
            return data;
        } else {
            return {
                success: false,
                message: data.message || "Failed to update profile"
            };
        }
    } catch (err) {
        console.log("Error in updating profile:", err);
        return {
            success: false,
            message: "Failed to connect to server. Please try again later."
        };
    }
};

export const createProfileFormData = (profileData, profileImage) => {
    const formData = new FormData();

    // Add all basic fields
    formData.append("fullName", profileData.fullName);
    formData.append("email", profileData.email);
    formData.append("contact", profileData.contact);
    formData.append("gender", profileData.gender);
    formData.append("dob", profileData.dob);
    formData.append("city", profileData.city);
    formData.append("isExperienced", profileData.isExperienced);

    if (profileData.summary) {
        formData.append("summary", profileData.summary);
    }

    // Add arrays as JSON strings
    formData.append("experiences", JSON.stringify(profileData.experiences || []));
    formData.append("educations", JSON.stringify(profileData.educations || []));
    formData.append("socialLinks", JSON.stringify(profileData.socialLinks || []));

    // Add image file if provided
    if (profileImage) {
        formData.append("profileImage", profileImage);
    }

    return formData;
};
